<template>
  <main-layout>
    <div class="p-5">
      <b-form>
        <b-form-group
            label="Niveau"
            label-class="font-weight-bold"
            label-cols="1">
          <b-form-radio-group
              id="niveau"
              class="pt-2"
              :options="dataNiveau"
              v-model="form.niveau"
          />
        </b-form-group>
        <b-form-group
            label="Type"
            label-class="font-weight-bold"
            label-cols="1">
          <b-form-radio-group
              id="type"
              class="pt-2"
              :options="dataType"
              v-model="form.type"
          />
        </b-form-group>
        <b-form-group
            label="Leçon"
            label-class="font-weight-bold"
            label-cols="1"
            content-cols="2">
          <b-form-input type="number"
                        v-model="form.lecon"/>
        </b-form-group>
        <b-form-group
            label="Titre"
            label-class="font-weight-bold"
            label-for="titre-input"
        >
          <b-form-input
              id="titre-input"
              v-model="form.titre"
          />
        </b-form-group>
        <b-form-group
            label="Tags"
            label-class="font-weight-bold"
            label-for="titre-input"
        >
          <vue-select
              id="tag-select"
              ref="tagSelect"
              v-model="form.tags"
              :options="tags"
              taggable
              multiple
          />
        </b-form-group>
        <b-form-group
            label="Image"
            label-class="font-weight-bold"
            label-for="image-input"
        >
          <b-form-input
              id="image-input"
              v-model="form.image"
          />
        </b-form-group>
        <b-form-group
            label="Contenu"
            label-class="font-weight-bold"
        >
          <vue-editor v-model="form.contenu"></vue-editor>
        </b-form-group>
        <b-form-group
            label="Contenu Cache"
            label-class="font-weight-bold"
        >
          <vue-editor v-model="form.contenu_cache"></vue-editor>
        </b-form-group>
        <b-form-group
            label="Document"
            label-class="font-weight-bold"
        >
          <vue-editor v-model="form.document"></vue-editor>
        </b-form-group>
        <b-form-group
            label="Description"
            label-class="font-weight-bold"
        >
          <vue-editor v-model="form.description"></vue-editor>
        </b-form-group>
        <back-btn-toolbar>
          <b-btn variant="primary" @click="submit" class="mr-1">SAUVER</b-btn>
        </back-btn-toolbar>
      </b-form>
    </div>
  </main-layout>
</template>

<script>
import {VueEditor} from "vue2-editor";
import BackBtnToolbar from "@/components/back-btn-toolbar";
import VueSelect from "vue-select"
import {Exercice, Produit} from "@/js/caller";
import {DataFormat} from "@/js/utils";
import $ from "jquery"

export default {
  name      : "ExerciceEditor",
  components: {BackBtnToolbar, VueEditor, VueSelect},
  data() {
    return {
      form      : {
        niveau       : "",
        type         : "",
        produit      : 0,
        titre        : "",
        tags         : [],
        image        : "",
        description  : "",
        contenu      : "",
        contenu_cache: "",
        document     : "",
        lecon        : 0
      },
      tags      : [],
      dataType  : DataFormat.Exercices.Type,
      dataNiveau: DataFormat.Exercices.Options.Niveau,
    }
  },
  watch  : {
    "$refs.tagSelect.$refs.search.value": (old, nouveau) => {
      console.log(old, nouveau);
    }
  },
  methods: {
    submit() {
      Exercice.Save(this.form).then(() => this.back());
    },
    reset() {
      this.form = {
        niveau       : "",
        type         : "",
        produit      : 0,
        titre        : "",
        tags         : [],
        image        : "",
        description  : "",
        contenu      : "",
        contenu_cache: "",
        document     : "",
        lecon        : 0
      }
    },
    back() {
      this.$router.back();
    },
    getSearchOption() {
      const search = this.$refs.tagSelect.$refs.search.value;
      console.log(search);
    }
  },
  created() {
    const {id} = this.$route.params;
    if (!id || id === 'new') return;
    Exercice.Get(id).then(res => this.form = res);
    Produit.Tags().then(tags => this.tags = tags);
  },
  mounted() {
    console.log("control", this.$refs.tagSelect.$el);
    console.log("jquery", $(this.$refs.tagSelect.$el).select2);
  }
}
</script>

<style scoped>

</style>